
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-3-os-bj-f-cflk-uyjd-fh-6-p-cx-6-t.json") })
        }
      }, "path---projects-c-3-os-bj-f-cflk-uyjd-fh-6-p-cx-6-t");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-3-os-bj-f-cflk-uyjd-fh-6-p-cx-6-t!./.cache/json/projects-c-3-os-bj-f-cflk-uyjd-fh-6-p-cx-6-t.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-3-os-bj-f-cflk-uyjd-fh-6-p-cx-6-t!./.cache/json/projects-c-3-os-bj-f-cflk-uyjd-fh-6-p-cx-6-t.json
// module chunks = 15178676390636814000